import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OnboardingService } from './services/onboarding.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public environment = environment;

  constructor(
    private onboardingService: OnboardingService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    // expose to window for debug
    (window as any).onboarding = this.onboardingService;
  }

  ngOnInit() {
  }

}
